import { render } from "./SocialItem.vue?vue&type=template&id=2f40aca8&scoped=true"
import script from "./SocialItem.vue?vue&type=script&lang=js"
export * from "./SocialItem.vue?vue&type=script&lang=js"

import "./SocialItem.vue?vue&type=style&index=0&id=2f40aca8&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f40aca8"]])

export default __exports__